module.exports = __webpack_public_path__ + "static/share-image-75a9d606e149aecd2f96393b855349f8.jpg";